import { plugins as base } from './lib/features/base';
import { plugins as AT } from './lib/features/AT';
import { plugins as CZ } from './lib/features/CZ';
import { plugins as RO } from './lib/features/RO';
import { plugins as SK } from './lib/features/SK';
import { plugins as RS } from './lib/features/RS';

export const plugins = {
    base,
    AT,
    CZ,
    RO,
    SK,
    RS,
};
